import { render, staticRenderFns } from "./aptitude.vue?vue&type=template&id=67739ae2&scoped=true&"
import script from "./aptitude.vue?vue&type=script&lang=js&"
export * from "./aptitude.vue?vue&type=script&lang=js&"
import style0 from "./aptitude.vue?vue&type=style&index=0&id=67739ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67739ae2",
  null
  
)

export default component.exports